import { createRoot } from 'react-dom/client';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import InvoicePublicLanding from './components/invoices/InvoicePublicLanding';
const agencyPreview = process.env.REACT_APP_AGENCY_PREVIEW_ONLY === '1';
const PrivateApplication = process.env.REACT_APP_AGENCY_PREVIEW_ONLY === '1'
    ? require('./components/AgencyPreviewApplication').default
    : require('./components/PrivateApplication').default;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(!agencyPreview && window.location.pathname === '/esave/adjuntar' ? <InvoicePublicLanding /> : (
    <ThemeProvider>
        <AuthProvider>
            <PrivateApplication />
        </AuthProvider>
    </ThemeProvider>
));
